import { ValidationMessage } from '../../_shared/models/shared.models';
import { isInvalidEmail, hasSpecialChars, isNullOrEmpty } from '../../_shared/shared.service';

export class Participant {
	Id: number;
	Name: string;
	JobTitle: string;
	Email: string;
	Phone: string;
	Organization: string;
	UniqueId: string;
	ProductId: number;
	IsAttending: boolean;
	TransactionId?: string;

	constructor(prodId: number) {
		this.Id = 0;
		this.Name = '';
		this.JobTitle = '';
		this.Email = '';
		this.Phone = '';
		this.Organization = '';
		this.UniqueId = null;
		this.IsAttending = true;
		this.ProductId = prodId;
	}

	isValid(): ValidationMessage {
		const errorAry: string[] = [];
		if (isNullOrEmpty(this.Name)) {
			errorAry.push('Name');
		} else if (hasSpecialChars(this.Name)) {
			return {
				HasError: true,
				Message: 'No special characters in name.',
			};
		}
		if (isNullOrEmpty(this.Email)) {
			errorAry.push('Email');
		} else if (isInvalidEmail(this.Email)) {
			return {
				HasError: true,
				Message: 'Email is not correct format.',
			};
		}
		if (isNullOrEmpty(this.Phone)) {
			errorAry.push('Phone');
		}
		return {
			HasError: errorAry.length > 0,
			Message: `Missing fields: ${errorAry.join(', ')}`,
		};
	}
}

export class ProcessingFormModel {
	Name?: string;
	Email?: string;
	Phone?: string;

	isValid(): ValidationMessage {
		const errorAry: string[] = [];

		if (isNullOrEmpty(this.Name)) {
			errorAry.push('Name');
		} else if (hasSpecialChars(this.Name)) {
			return {
				HasError: true,
				Message: 'No special characters in name.',
			};
		}
		if (isNullOrEmpty(this.Email)) {
			errorAry.push('Email');
		} else if (isInvalidEmail(this.Email)) {
			return {
				HasError: true,
				Message: 'Email is not correct format.',
			};
		}
		if (isNullOrEmpty(this.Phone)) {
			errorAry.push('Phone');
		}
		return {
			HasError: errorAry.length > 0,
			Message: `Missing fields: ${errorAry.join(', ')}`,
		};
	}
}
